'use client';

import { useCallback, useEffect, useRef, useState } from 'react';

/** The keys the search's hints show. */
export type HintKey = 'up' | 'down' | 'enter' | 'tab' | 'esc' | 'shortcut';

const FLASH_MS = 160;

/** Which hint's key was just pressed, for a moment, so its cap can dip. */
export function useKeyFlash() {
  const [hitKey, setHitKey] = useState<HintKey | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

  const flash = useCallback((key: HintKey) => {
    setHitKey(key);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setHitKey(null), FLASH_MS);
  }, []);

  useEffect(() => () => clearTimeout(timer.current), []);

  return { hitKey, flash };
}
